module.exports = __webpack_public_path__ + "static/media/banco-do-brasil.e29c395f.png";